import { useCallback } from 'react';
import { useUser } from '@store';
import { canManageUserAccess } from '../utils/roleUtils';

/**
 * Returns a predicate answering: can the *current* logged-in user modify the
 * given target user's access (rooftops / features)?
 *
 * Wraps `canManageUserAccess` with the current user's role from the store, so
 * callers only pass the target user's role. See `canManageUserAccess` for the
 * rule (super admins are only manageable by other super admins).
 */
export function useCanManageUserAccess(): (targetUserRole: string) => boolean {
  const currentUserRole = useUser()?.profile?.default_role;
  return useCallback(
    (targetUserRole: string) => canManageUserAccess(currentUserRole, targetUserRole),
    [currentUserRole],
  );
}
